import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $f7router = _ref.$f7router;
  var urls = {
    downloadPrivacy: DOCUMENTS_ADDRESS + 'privacy_it.pdf',
    downloadTermsAndConditions: DOCUMENTS_ADDRESS + 'terms_and_conditions_it.pdf',
    downloadReceiveADV: DOCUMENTS_ADDRESS + 'receive_adv_it.pdf'
  };
  var url, document;

  var openPopup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
      var file_exists, l, file, html, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file_exists = ['en', 'it', 'fr', 'es', 'de'];
              l = file_exists.find(function (item) {
                return item == lng.key;
              }) || file_exists[0];
              file = 'static/html/' + $(ev.target).data('text') + '_' + l + '.html';

              if (!$f7.device.cordova) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return myApp.server.readFile(file);

            case 6:
              html = _context.sent;
              _context.next = 15;
              break;

            case 9:
              _context.next = 11;
              return fetch(file);

            case 11:
              res = _context.sent;
              _context.next = 14;
              return res.text();

            case 14:
              html = _context.sent;

            case 15:
              document = $(ev.target).data('text');
              url = DOCUMENTS_ADDRESS + document + '_' + l + '.pdf';
              $('.popup-docs').find('.content').html(html);
              $f7.popup.open('.popup-docs');

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openPopup(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var viewPDF = function viewPDF() {
    myApp.iab(url, '_system');
  };

  var shareViaEmail = function shareViaEmail() {
    var w = window.innerWidth;
    window.plugins.socialsharing.canShareViaEmail(function () {
      window.plugins.socialsharing.shareViaEmail(url, // can contain HTML tags, but support on Android is rather limited:  http://stackoverflow.com/questions/15136480/how-to-send-html-content-with-image-through-android-default-email-client
      'DoctorPass ' + lng.documents, null, // TO: must be null or an array
      null, // CC: must be null or an array
      null, // BCC: must be null or an array
      url, // FILES: can be null, a string, or an array
      function (onSuccess) {
        // called when sharing worked, but also when the user cancelled sharing via email. 
        // On iOS, the callbacks' boolean result parameter is true when sharing worked, false if cancelled. 
        // On Android, this parameter is always true so it can't be used. 
        console.log('Share via email success');
        if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
      }, function (onError) {
        // called when sh*t hits the fan
        $f7.dialog.alert(lng.error_message + '<br/>' + onError, function () {
          if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
        });
      });
    }, function () {
      window.plugins.socialsharing.shareWithOptions({
        message: 'DoctorPass ' + lng.documents + '\r\n' + url,
        chooserTitle: lng.select_app
      }, function () {
        if (w !== window.innerWidth) window.location.reload();
      }, function () {
        if (w !== window.innerWidth) window.location.reload();
      });
    });
  };

  var shareViaWA1 = function shareViaWA1() {
    var w = window.innerWidth;
    window.plugins.socialsharing.shareViaWhatsApp('DoctorPass ' + lng.documents + '\r\n' + url, null, null, function (success) {
      if (w !== window.innerWidth) window.location.reload();
    }, function (errormsg) {
      return $f7.dialog.alert(lng.error_message + '<br/>' + errormsg);
    }, function () {
      if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
    });
  };

  var shareViaWA = function shareViaWA() {
    var w = window.innerWidth;
    window.plugins.socialsharing.canShareVia('whatsapp', 'msg', null, null, null, shareViaWA1, function (e) {
      window.plugins.socialsharing.shareWithOptions({
        message: 'DoctorPass ' + lng.documents + '\r\n' + url,
        chooserTitle: lng.select_app
      }, function () {
        if (w !== window.innerWidth) window.location.reload();
      }, function () {
        if (w !== window.innerWidth) window.location.reload();
      });
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">${lng.privacy_title}</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white display-flex justify-content-center align-items-center flex-direction-column">
      <img width="150" class="margin-bottom" src="static/logo.png" alt=""/>
      <div class="block margin-top padding-top">
        <h4 class='text-align-center'>${lng.privacy_message}</h4>
        <a class="link button button-fill button-large button-round margin-vertical-half popup-open" href="#"
           data-popup=".popup-docs" data-text="privacy" @click=${openPopup}>
          <i class="f7-icons left">doc</i>
          Privacy
        </a>
        <a class="link button button-fill button-large button-round margin-vertical-half popup-open" href="#"
           data-popup=".popup-docs" data-text="terms_and_conditions" @click=${openPopup}>
          <i class="f7-icons left">doc</i>
          ${lng.general_conditions}
        </a>
        <a class="link button button-fill button-large button-round margin-vertical-half popup-open" href="#"
           data-popup=".popup-docs" data-text="receive_adv" @click=${openPopup}>
          <i class="f7-icons left">doc</i>
          ${lng.receive_adv_caption}
        </a>
      </div>

    </div>

    <div class="popup popup-docs popup-tablet-fullscreen unselectable">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg bg-color-white"></div>
            <div class="navbar-inner">
              <div class="left margin-left">
                <a href="#" class="text-color-blue margin float-left actions-open" data-actions=".my-actions">
                  <i class="f7-icons">square_arrow_up</i>
                </a>
              </div>
              <a href="#" class="right link text-color-blue popup-close">
                <span>${lng.close}</span>
                <i class="f7-icons right">xmark</i></a>
            </div>
          </div>
          <div class="page-content overflow-auto bg-color-white">
            <div class="content popup-lg-content"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions-modal my-actions">
      <div class="actions-group">
        <div class="actions-label">
          ${lng.select_action}
        </div>
        <div class="actions-button color-blue">
          <div class="actions-button-media">
            <i class="f7-icons">arrow_down_doc</i>
          </div>
          <div class="actions-button-text">
            <a class="actions-close" @click=${viewPDF} href="#">${lng.show} / download PDF</a>
          </div>
        </div>
        <div class="actions-button color-blue">
          <div class="actions-button-media">
            <i class="f7-icons">at</i>
          </div>
          <div class="actions-button-text">
            <a class="actions-close" @click=${shareViaEmail} href="#">${lng.share_via_email}</a>
          </div>
        </div>
        <div class="actions-button color-blue">
          <div class="actions-button-media">
            <i class="f7-icons">chat_bubble_text</i>
          </div>
          <div class="actions-button-text">
            <a class="actions-close" @click=${shareViaWA} href="#">${lng.share_via_wa}</a>
          </div>
        </div>
        <div class="actions-button color-gray">
          <a class="actions-close" href="#">${lng.cancel}</a>
        </div>
      </div>
    </div>

  </div>



`
    }
    ;
});